export class PrzeniesSrodkiModel {
    srodkiId: Array<string> = new Array()
    pomieszczenieDoceloweId: string
    pomieszczenieAktualneId: string
}